'use strict';

module.exports = function(source) {
    return JSON.parse(JSON.stringify(source));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/virtual-scroll/src/clone.js
// module id = 551
// module chunks = 0